import Remote from '../shared/remote';
import Utils from '../shared/utils';
import Panel from '../shared/panels';
import CommentEditor from '../shared/components/comment_editor';
import { ImmersiveReaderButtonRenderer } from '../shared/reactLoader';

const setCommentCount = () => {
  $('.lp--js-commentCount').html($('.lp--commentsSection > .lp--commentItem:not(.hidden)').length);
};

const addingCommentToView = (html) => {
  let height = $('.lp--commentsSection').append(html).height();
  $('.coms-pane .pr2--nodePanelBody').scrollTop(height);
};

export default class Comments {
  get eventSource() {
    if (!this._eventsource) {
      this._eventsource = $({});
    }
    return this._eventsource;
  }

  constructor(options) {
    this.options = options;
    this.remote = new Remote('', {});

    this.loginModal = null;
    this.commentNumber = 0;

    this.globalReplyHandler = (event) => {
      let $parent = $(event.target).parents('.lp--commentItem');
      if (!this.replyEditors[$parent[0].id]) {
        if (this.editor) {
          this.editor.blur();
        }

        let cont = $('<div>');
        $parent.append(cont);

        let replyEditor = new CommentEditor(
          cont[0],
          {
            item: { attachments: [], body: '', type: '' },
            user: null,
            type: 'comment',
            provideSave: true,
          },
          {
            buttonText: i18n.__('app_send'),
            supportPrivate: true,
            integrations: this.options.integrations,
            upload: {
              url: this.options.fileservice.url,
              formData: {
                signature: this.options.signature,
                timestamp: this.options.timestamp,
                circle: this.options.circle_id,
                context: this.options.circle_id,
              },
            },
          },
        );
        replyEditor.eventSource.on('save', (event, item) => {
          const entityUuid = $parent[0].id;
          this.save(item.body, item.attachments, item.protected, item.type, 'comment', entityUuid, replyEditor)
            .then((result) => {
              const data = {
                entity_uuid: entityUuid,
                entity_type: 'comment',
                html: result.html,
              };
              let e = $.Event('comment.posted', data);
              this.eventSource.trigger(e);
              cont.remove();
              replyEditor.destroy();
              this.replyEditors[entityUuid] = false;
            })
            .catch(() => {
              // No op
            });
        });
        $('.replyer' + $parent[0].id).focus();
        this.replyEditors[$parent[0].id] = replyEditor;
      } else {
        this.replyEditors[$parent[0].id].blur();
      }
    };

    this.deleteHandler = (event) => {
      const item = $($(event.currentTarget).parents('.lp--js-commentItem')[0]);
      const entityId = item.attr('data-uuid');
      this.remote
        .delete('comments/' + entityId)
        .then(() => {
          item.remove();
          setCommentCount();
          const commentsSection = $('.lp--commentsSection');
          const isEmpty = !$.trim(commentsSection.html());
          if (isEmpty) {
            const entity = this.openEntity ? this.openEntity : this.previousEntity;
            this.eventSource.trigger($.Event('comment.empty', entity));
            this.panel.hide();
          }
        })
        .catch(function () {
          flash(i18n.__('error_delete_comment'), { ttl: 3000 });
        });
    };

    $(document).on(Utils.interactionEvent, '.lp--js-commentReply', this.globalReplyHandler);
    $(document).on(Utils.interactionEvent, '.lp--js-commentDelete', this.deleteHandler);

    this.replyEditors = {};
  }

  init() {
    $(document).on('comment.request_post', (ev) => {
      this.open(ev.entity_type, ev.entity_uuid, {
        activity_type: ev.activity_type,
      });
    });

    $(document).on(Comments.EventTriggerName, (ev, data) => {
      this.isProtected = data.isProtected;
      this.open(data.entity_type, data.entity_uuid, {
        activity_type: data.activity_type,
      });
    });

    $(document).on('toggleComments', (ev) => {
      const { entityType, entityId } = ev.detail;
      this.open(entityType, entityId, { reopen: true });
    });

    this.eventSource.on('comment.posted', (ev) => {
      const html = ev.html;
      if (ev.entity_type === 'comment') {
        $('#' + ev.entity_uuid)
          .children('.lp--js-commentReplies')
          .append(html);
      } else {
        addingCommentToView(html);
      }
      setCommentCount();
      this.renderImmersiveReaderButton();
    });

    $('body').on('comment.posted', (ev) => {
      if (ev.entity_type === 'comment') {
        $('#' + ev.entity_uuid)
          .children('.lp--js-commentReplies')
          .append(ev.html);
      } else {
        $('.lp--commentsSection').append(ev.html).children().last().find('.lp--js-commentReply');
      }
      setCommentCount();
      this.renderImmersiveReaderButton();
    });
  }

  on_no_access() {
    let content_modal = $('#content-modal');
    content_modal.modal('hide');
    if (this.loginModal == null) {
      this.loginModal = new LoginModal(this.remote, '#content-modal');
    }
    this.loginModal.open();
  }

  resetContent(editor) {
    editor.resetItem();
  }

  markNotificationsAsRead() {
    let nodeId;
    let studentUuid;
    if (window.viewer) {
      nodeId = window.viewer.currentNode.id();
      studentUuid = window.viewer.userUuid;
      window.viewer.removeNotificationById(nodeId);
    } else if (this.options.viewer) {
      nodeId = this.options.viewer.activity.uuid;
      studentUuid = this.options.viewer.student.uuid;
    }
    this.remote.put(`notifications/read/${nodeId}/${studentUuid}`);
    $(`.activity-item[data-uuid=${nodeId}]`).removeClass('accepted');
    document.dispatchEvent(new CustomEvent('notification.read', { detail: { studentUuid, nodeId } }));
  }

  open(entity_type, entity_id, opts = {}) {
    if (
      this.panel &&
      this.openEntity &&
      this.openEntity.entity_id === entity_id &&
      this.openEntity.entity_type === entity_type
    ) {
      this.panel.hide();
      // Godawful work around for state mismanagement
      this.previousEntity = this.openEntity;
      this.openEntity = null;
    }
    if ($('.coms-pane.open').length === 0) {
      this.openEntity = { entity_type, entity_id };
      this.loadAndThen(entity_type, entity_id, opts);
    }
  }

  renderImmersiveReaderButton() {
    [...this.panel.content[0].querySelectorAll('.ir-button:not([id])')].forEach((element) => {
      const id = `commentIrButton${this.commentNumber++}`;
      element.setAttribute('id', `${id}Wrapper`);
      ImmersiveReaderButtonRenderer.render(id);
    });
  }

  loadAndThen(entity_type, entity_id, opts) {
    $(document).trigger('comment.open');
    this.load(entity_type, entity_id)
      .then((result) => {
        this.panel = new Panel(Panel.COMS, result.html, { bindToMain: true });

        this.setup(entity_type, entity_id);

        this.panel.eventSource.on('willHide.panel', () => {
          notifications.unsubscribe(entity_id);
        });

        notifications.subscribe(entity_id);

        this.panel.eventSource.on('added.panel', () => {
          this.panel.content
            .find('.pr2--nodePanelBody')
            .scrollTop(this.panel.content.find('.pr2--nodePanelBody').get(0).scrollHeight);
        });

        if (opts.temporaryContext) {
          this.panel.content
            .find('.lp--commentContext h2')
            .addClass('lp--commentContext-selection')
            .text(opts.temporaryContext);
        }

        this.markNotificationsAsRead();
        this.panel.eventSource.on('added.panel', () => {
          this.renderImmersiveReaderButton();
        });

        this.panel.show();

        if (opts.activity_type) {
          $('.coms-pane').addClass(opts.activity_type);
        }
      })
      .catch((result) => {
        console.error(result);
      });
  }

  load(entity_type, entity_id) {
    return this.remote
      .get('comments/' + entity_type + '/' + entity_id + '/' + this.options.session_id + '/comments', { type: 'json' })
      .on('noAccess', () => this.on_no_access());
  }

  setup(entity_type, entity_id) {
    if (!this.options.read_only) {
      this.editor = new CommentEditor(
        this.panel.content.find('.lp--js-formContainer')[0],
        {
          item: { attachments: [], body: '', type: '' },
          user: null,
          type: 'comment',
          provideSave: true,
        },
        {
          buttonText: i18n.__('app_send'),
          supportPrivate: entity_type !== 'selection' && !this.isProtected,
          integrations: this.options.integrations,
          upload: {
            url: this.options.fileservice.url,
            formData: {
              signature: this.options.signature,
              timestamp: this.options.timestamp,
              circle: this.options.circle_id,
              context: this.options.circle_id,
            },
          },
        },
      );

      this.editor.eventSource.on('save', (ev, item) => {
        this.save(item.body, item.attachments, item.protected, item.type, entity_type, entity_id, this.editor)
          .then((result) => {
            this.eventSource.trigger(
              $.Event('comment.posted', {
                entity_uuid: entity_id,
                entity_type: entity_type,
                html: result.html,
              }),
            );
          })
          .catch(() => {
            // No op
          });
      });
    }
  }

  save(content, attachments, isProtected, type, entity_type, entity_id, editor) {
    const data = {
      body: content,
      attachments: attachments,
      protected: isProtected || this.isProtected,
      type: type,
      session_id: this.options.session_id,
    };
    return this.remote
      .post('comments/' + entity_type + '/' + entity_id + '/comments', data)
      .on('noAccess', () => this.on_no_access())
      .then((result) => {
        this.resetContent(editor);
        return result;
      })
      .catch((err) => {
        if (err && err.message === 'empty_comment ') {
          flash(i18n.__('comment_empty_error_message'), { ttl: 3000, type: 'status' });
        } else {
          flash(i18n.__('error_post_comment'), { ttl: 3000 });
        }
        throw err;
      });
  }
}

Comments.EventTriggerName = 'comment.request_post2';
